import {Injectable} from "@angular/core";
import {AlertController, type AlertOptions} from "@ionic/angular";

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private instance: HTMLIonAlertElement;

  constructor(private readonly alert: AlertController) {}

  async present(options: AlertOptions): Promise<HTMLIonAlertElement> {
    options.buttons = options.buttons ?? [{text: 'Okay'}];
    this.instance = await this.alert.create(options);

    await this.instance.present();
    return this.instance;
  }

  dismiss(): void {
    if (!!this.instance) {
      this.instance.dismiss().then();
    }
  }
}
